import { MinLength, MaxLength } from "class-validator";
import {validate, validateOrReject, Contains, IsInt, Length, IsEmail, IsFQDN,
        IsDate,Min,Max } from "class-validator";
import {ValidateIf, IsNotEmpty,IsNumber,IsString,IsEmpty } from "class-validator";


export class Sysuser {
    // @MaxLength(10,{message: 'COMPANY 字串太長'})
    // @IsString({message: 'COMPANY 不是字串型態'})
    COMPANY: string = '';

    // @MaxLength(10)
    CREATOR: string = '';

    // @MaxLength(10)
    USR_GROUP: string = '';

    // @MaxLength(8)
    CREATE_DATE: string ='';

    // @MaxLength(10)
    MODIFIER: string = '';

    // @MaxLength(8)
    MODI_DATE: string = '';

    // @IsNumber()
    // @Max(999)
    FLAG: number =0;


    // @MaxLength(10,{message: '客戶代號 (CUSTOMER) 資料太長'})
    CUSTOMER: string = '';            // 客戶代號 10 951031 ADD

    // @MaxLength(200,{message: 'E-Mail帳號 (EMAIL) 資料太長'})
    EMAIL: string = '';            // E-Mail帳號 200 單一mail: a// @company.com  多mail:<a// @company.com>;<b// @company.com> 940703 ADD

    // @MaxLength(255,{message: '可登入公司 (PS) 資料太長'})
    PS: string = '';            // 可登入公司 255 以逗點分開

    // @MaxLength(36,{message: '密碼 (Password) 資料太長'})
    Password: string = '';            // 密碼 36

    // @IsNotEmpty({message: '登入者代號 (UserID) 不可空白'})
    // @MaxLength(10,{message: '登入者代號 (UserID) 資料太長'})
    UserID: string = '';            // 登入者代號 10 登入者代號

    // @MaxLength(10,{message: '登入者名稱 (UserName) 資料太長'})
    UserName: string = '';            // 登入者名稱 10 登入者名稱

    // @MaxLength(10,{message: '廠商代號 (VENDOR) 資料太長'})
    VENDOR: string = '';            // 廠商代號 10 951031 ADD

    //// @IsDate()
    WA008: Date | undefined ;            // 最後登入時間 0 記錄最後一次登入時間(Datetime) 960403 ADD

    // @MaxLength(6,{message: '部門代號 (WA009) 資料太長'})
    WA009: string = '';            // 部門代號 6

    // @MaxLength(10,{message: '主要代理人 (WA010) 資料太長'})
    WA010: string = '';            // 主要代理人 10 JOIN SYSUSER.USERID

    // @MaxLength(10,{message: '主管代號 (WA011) 資料太長'})
    WA011: string = '';            // 主管代號 10 JOIN SYSUSER.USERID

    // @MaxLength(8,{message: '停用日期 (WA012) 資料太長'})
    WA012: string = '';            // 停用日期 8

    // @MaxLength(10,{message: '員工編號 (WA013) 資料太長'})
    WA013: string = '';            // 員工編號 10 join CMSMV

    // @MaxLength(8,{message: '起始代理日期 (WA014) 資料太長'})
    WA014: string = '';            // 起始代理日期 8

    // @MaxLength(8,{message: '結束代理日期 (WA015) 資料太長'})
    WA015: string = '';            // 結束代理日期 8

    // @MaxLength(10,{message: '代理人員工號 (WA016) 資料太長'})
    WA016: string = '';            // 代理人員工號 10


}
